import script from "./TestsetsTabComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestsetsTabComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TestsetsTabComponent.vue?vue&type=style&index=0&id=c5fd4bac&lang=scss"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QDialog,QCard,QCardSection,QSpace,QBtn,QInput,QEditor,QPopupEdit,QExpansionItem,QCheckbox});qInstall(script, 'directives', {ClosePopup});
